import {GridLoader} from 'react-spinners'

export default function AppLoader({text ,className}) {


    return (
        <div className={`w-full h-max flex items-center justify-center flex-col gap-2 ${className}`}>
            <GridLoader color="#ff8a00" />
            <p className="text-neutral-500">{text || "Loading data ..."}</p>
        </div>
    )


}